module.exports = __webpack_public_path__ + "img/sabaz_1.b1b646eb.png";